"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_NOFOLLOW_KEY = exports.LINK_TARGET_BLANK_KEY = exports.LINK_URL_KEY = exports.LINK_SHORTCUT = exports.LinkTypes = exports.savedLinkFields = exports.hslinkConfig = exports.LINK_SETTINGS = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var LINK_SETTINGS = 'hsLink';
exports.LINK_SETTINGS = LINK_SETTINGS;
var hslinkConfig = {
  HIDE_TARGET_BLANK_AND_NO_FOLLOW: 'hideTargetBlankAndNoFollow',
  ALLOW_RELATIVE_LINKS: 'allowRelativeLinks',
  ALLOW_FILE_DOWNLOAD: 'allowFileDownload',
  ALLOW_MEETING_LINKS: 'allowMeetingLink',
  ALLOW_ANCHOR_LINKS: 'allowAnchorLinks'
};
exports.hslinkConfig = hslinkConfig;
var savedLinkFields = {
  HREF: 'href',
  TEXT: 'linkText',
  REL: 'rel',
  TARGET: 'target'
};
exports.savedLinkFields = savedLinkFields;
var LinkTypes = (0, _keyMirror.default)({
  STANDARD: null,
  EMAIL_SYSTEM: null
});
exports.LinkTypes = LinkTypes;
var LINK_SHORTCUT = '@command:LINK_SHORTCUT';
exports.LINK_SHORTCUT = LINK_SHORTCUT;
var LINK_URL_KEY = 'url';
exports.LINK_URL_KEY = LINK_URL_KEY;
var LINK_TARGET_BLANK_KEY = 'target_blank';
exports.LINK_TARGET_BLANK_KEY = LINK_TARGET_BLANK_KEY;
var LINK_NOFOLLOW_KEY = 'nofollow';
exports.LINK_NOFOLLOW_KEY = LINK_NOFOLLOW_KEY;